import { Injectable, ErrorHandler } from '@angular/core';
import { AppInsightsService } from './app-insights.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private appInsightsService: AppInsightsService) {
    super();
  }

  override handleError(error: Error) {
    this.appInsightsService.logException(error);
    super.handleError(error);
  }
}
